import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withTranslation } from "react-i18next";
import React from "react";
import { useSnackbar } from "notistack";

import PasswordReset from "./PasswordReset";

const PasswordResetWithSnackbar = (props) => {
  const snackbar = useSnackbar();
  return React.createElement(PasswordReset, { ...props, ...snackbar });
};

const mapStateToProps = (_state) => ({});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(PasswordResetWithSnackbar),
);
